import React  from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import Text,{H1} from '@dbk/ui-text';
import { Info2 } from '@dbk/ui-icons';
import {Currency } from '../../components/common/number';
import styles from './summary-header-styles';
import Popover from '../popover-component'
import { PALETTE } from '../../constants';
import { StyleSheet } from 'react-native';

/* Summary Total Market Value Header */
function SummaryHeader({
    messages,
    prefCurrency,
    mktValueTotal,
    asOfDate
}){

    return(
        <div>
            <div className='summary-header-total-parent'>
             <Text secondary size="large" tabIndex={0}>
            {messages['app.dashboard.summaryData.marketValue.total.title']}
            </Text> 
            <Popover
                mode="popup"
                orientation="right"
                showOnHover
                popOverClassName="dashboard-summary-popover"
                arrowColor={PALETTE.secondaryActive}
                content={
                  <div>
                    <p>{messages["app.dashboard.summaryData.popoverTxt1"]}</p>
                    <p>{messages["app.dashboard.summaryData.popoverTxt2"]}</p>
                    <p>{messages["app.dashboard.summaryData.popoverTxt3"]}</p>
                  </div>}
              >
                <span aria-label={
                  messages['app.dashboard.toolTip'] + " "+
                  messages["app.dashboard.summaryData.popoverTxt1"] +" " +
                  messages["app.dashboard.summaryData.popoverTxt2"] + " " + 
                  messages["app.dashboard.summaryData.popoverTxt3"]
                  }>
                  <Info2 className="dashboard-total-mkt-val-Qmark" color={PALETTE.fordGray} height={30} width={30}/>
                </span>
              </Popover>
              
              </div>
            <H1 className = "summary-header-value margin-top-5 margin-bottom-5" tabIndex={0}>
            <Currency
                    signBeforeNumber={false}
                    decimalStyle={styles.decimelStyle}
                    currencyStyle = {StyleSheet.flatten(styles.currencyStyle)}
                    currency={prefCurrency}
                    renderProps={{
                        style: styles.marketTotalHeaderNomination,
                        size: 40
                    }}
                    value={mktValueTotal}
                />
            {/* <Text className = "summary-header-currency">{prefCurrency}</Text> */}
            </H1>
            <Text  size ="big" tabIndex={0}>
            {messages['app.dashboard.summaryData.title']}{asOfDate}
            </Text>
            </div>
    );

}
   
SummaryHeader.propTypes = {
    mktValueTotal: PropTypes.number,
    prefCurrency: PropTypes.string,
  };
  
  
export default pure(SummaryHeader);